// jQuery Validation
// Ref about import loader config : http://stackoverflow.com/a/28989476
require('imports-loader?define=>false&jQuery=jquery!jquery-validation/dist/jquery.validate.min.js');

// Localisation
//
require("./localization.js");


// Validation
//
require("./validation.js");


// WEBPACK FOOTER //
// ./Sig.Web/src/utils/forms-validation/index.js